// react
import React, { Fragment, useState, useContext, useEffect } from "react";

// react router
import { useNavigate } from "react-router-dom";

// constants
import { PATHS } from "../../constants/paths";

//helper
import { parseJwt } from "../../helpers/auth/parseJwt";
import { persistAuth } from "../../helpers/auth/auth";

//component
import { Button, Form, Input, Alert, Row, Col, Switch } from "antd";
import AskForNotifications from "../../components/Login/AskForNotifications/AskForNotifications";

// services
import { loginUser } from "../../services/user";
import { getDeviceToken } from "../../firebase";

// context
import { AuthContext } from "../../context/AuthContext";

// auth actions
import * as authActionTypes from "../../constants/actionTypes/auth";
import { pickerLogin } from "../../services/picker";

const Login = () => {
  const navigate = useNavigate();

  const {
    state: { isAuthenticated, user, homePath },
    dispatch,
  } = useContext(AuthContext);

  const [buttonDisabled, setButtonDisabled] = useState(false);

  const [formError, setFormError] = useState();

  const [isRequestNotificationsAccepted, setIsRequestNotificationsAccepted] =
    useState(false);

  const requestNotificationsAcceptedHandler = () => {
    setIsRequestNotificationsAccepted(true);
  };

  const requestNotificationsRejectedHandler = () => {
    setIsRequestNotificationsAccepted(false);
  };

  const [isRedirectingFromLogin, setIsRedirectingFromLogin] = useState(false);

  // useEffect(() => {
  //   if (isRedirectingFromLogin) return;
  //   if (isAuthenticated && user.isValidToken) {
  //     navigate(homePath || "/not-found");
  //   } else if (isAuthenticated && !user.isValidToken) {
  //     navigate(PATHS.validate2fa);
  //   }
  // }, [
  //   navigate,
  //   isAuthenticated,
  //   user.isValidToken,
  //   homePath,
  //   isRedirectingFromLogin,
  // ]);

  useEffect(() => {
    if (!isAuthenticated) return; // skip if not logged in
    if (user.role === "picker") {
      navigate(PATHS.pickerTab);
    } else if (!user.isValidToken && user.role !== "picker") {
      navigate(PATHS.validate2fa);
    } else {
      navigate(homePath || "/not-found");
    }
  }, [navigate, user, isAuthenticated, isRedirectingFromLogin, homePath]);

  // useEffect(() => {
  //   if (isAuthenticated && user.isValidToken) {
  //     navigate(homePath || "/not-found");
  //   } else if (isAuthenticated && !user.isValidToken) {
  //     navigate(PATHS.validate2fa);
  //   }
  // }, [navigate, isAuthenticated, user.isValidToken, homePath]);

  const onSubmitLogin = async (data) => {
    setButtonDisabled(true);
    let response;

    if (isRequestNotificationsAccepted) {
      const fcmId = await getDeviceToken();
      if (fcmId) {
        data.fcmId = fcmId;
      }
    }

    try {
      if (data.isPickerLogin) {
        response = await pickerLogin(data);
      } else {
        response = await loginUser(data);
      }

      const {
        data: { jwtToken, isValidToken, qrCode, is2faEnabled },
      } = response;
      const parsedUser = parseJwt(jwtToken);
      const user = {
        ...parsedUser,
        isValidToken:
          isValidToken !== undefined
            ? isValidToken
            : parsedUser.role === "picker",
        qrCode,
        is2faEnabled,
      };

      persistAuth(user, jwtToken);

      dispatch({
        type: authActionTypes.LOGIN,
        payload: user,
      });

      if (user.role === "picker") {
        setIsRedirectingFromLogin(true);
        navigate(PATHS.pickerTab);
      } else {
        setIsRedirectingFromLogin(true);
        navigate(PATHS.validate2fa);
      }
    } catch (error) {
      if (error.response.status === 401) {
        setFormError("invalid credentials");
      } else {
        setFormError("something went wrong !");
      }
    }

    setButtonDisabled(false);
  };

  return (
    <Fragment>
      <AskForNotifications
        onAccept={requestNotificationsAcceptedHandler}
        onReject={requestNotificationsRejectedHandler}
      />
      <header
        className="d-flex align-items-center"
        style={{ backgroundColor: "#122955" }}
      >
        <img
          src="https://i.imgur.com/Cx6rjiB.png"
          alt="mtor logo"
          width="100px"
          className="ms-4"
        />
        <span className="display-5 text-light">mtor | Login Page</span>
      </header>

      <div className="py-5">
        {formError && (
          <Alert
            className="w-50 mx-auto"
            message="Error"
            description={formError}
            type="error"
            showIcon
          />
        )}

        <Form
          name="login-form"
          layout="vertical"
          onFinish={onSubmitLogin}
          className="py-5"
        >
          <Row justify={"center"}>
            <Col lg={12} xs={22}>
              <Form.Item
                label="Username"
                name="username"
                rules={[
                  {
                    required: true,
                    message: "Please input your username!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row justify={"center"}>
            <Col lg={12} xs={22}>
              <Form.Item
                label="Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>
            </Col>
          </Row>
          <Row justify={"center"}>
            <Col lg={12} xs={22}>
              <Form.Item
                label="Picker Login"
                name="isPickerLogin"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
          </Row>
          <Row justify="center">
            <Col lg={6} xs={11}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={buttonDisabled}
                  loading={buttonDisabled}
                >
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Fragment>
  );
};

export default Login;
